export default __webpack_public_path__ + "static/media/list-icon.2996ea9f.svg";